<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 订单管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>出库信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-input v-model="query.outStockNo" placeholder="出货单号" class="handle-input mr10" style="width:180px;"></el-input>
				<el-select v-model="query.orderCompanyId" placeholder="请选择客户" filterable>
					<el-option key="" label="请选择客户" value=""></el-option>
					<el-option v-for="item in customersKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.expressId" placeholder="送达方式">
					<el-option key="" label="请选择送达方式" value=""></el-option>
					<el-option v-for="item in expressKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-input v-model="query.expressNo" placeholder="快递单号" class="handle-input mr10" style="width:180px;"></el-input>
				<el-input v-model="query.tel" placeholder="收件人手机号" class="handle-input mr10" style="width:180px;"></el-input>
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="outStockNo" label="出货单号" width = "160px"></el-table-column>
				<el-table-column prop="orderCompanyName" label="客户"></el-table-column>
                <el-table-column prop="expressNo" label="快递单号"  width = "180px"></el-table-column>
				<el-table-column prop="addressee" label="收件人" width = "150px"></el-table-column>
				<el-table-column prop="tel" label="手机号" width = "120px"></el-table-column>
				<el-table-column prop="reviewerName" label="复核人" width = "100px"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" width = "160px"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if = "controll['edit'] && scope.row.reviewerId === 0"
                        >编辑</el-button>
						<el-button
                            type="text"
                            icon="el-icon-view"
                            @click="handleShow(scope.$index, scope.row)"
							v-if = "controll['show']"
                        >详情</el-button>
						<el-button
                            type="text"
                            icon="el-icon-printer"
                            @click="exportOutStock(scope.$index, scope.row)"
							v-if = "controll['export'] && scope.row.reviewerId > 0 && scope.row.storekeeperId === 0"
                        >下载打印</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if = "controll['delete'] && scope.row.reviewerId === 0"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="40%">
            <el-form ref="form" :model="form" label-width="80px" :rules="rules">
				<el-form-item label="出库单号" prop="outStockNo">
                    <el-input v-model="form.outStockNo" :disabled="isDisabled"></el-input>
                </el-form-item>
				<el-form-item label="客户" prop="orderCompanyName">
					<el-input v-model="form.orderCompanyName" ></el-input>
				</el-form-item>
				<el-form-item label="送达方式" prop="expressId">
					<el-select v-model="form.expressId" placeholder="送达方式">
						<el-option key="" label="请选择送达方式" value=""></el-option>
						<el-option v-for="item in expressKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="单号" prop="expressNo">
					<el-input v-model="form.expressNo"></el-input>
				</el-form-item>
				<el-row>
					<el-col :span= "19">
						<el-form-item label="收货人" prop="addressee">
							<el-input v-model="form.addressee"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span= "5" align="right" style="padding-right:5px;">	
						<el-button @click="handleExpressAddress(form.orderCompanyId)">历史收件人</el-button>
					</el-col>
				</el-row>
				<el-form-item label="联系电话" prop="tel">
					<el-input v-model="form.tel"></el-input>
				</el-form-item>
				<el-form-item label="收货地址" prop="address">
					<el-input v-model="form.address"></el-input>
				</el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
		
		<!-- 出库单详情 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false title="出库单详情" :visible.sync="showVisible" width="70%">
            <el-tabs v-model="activeName" type="card">
				<el-tab-pane label="基本信息" name="baseTab">
					<el-form ref="show" :model="show" label-width="100px">
						<el-descriptions class="margin-top" title="" :column="2" size="medium" border>
							<el-descriptions-item>
								<template slot="label">
									出库单号
								</template>
								{{show.outStockNo}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									客户
								</template>
								{{show.orderCompanyName}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									送达方式
								</template>
								{{expressFormat('', '', show.expressId)}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									单号
								</template>
								{{show.expressNo}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									收货人
								</template>
								{{show.addressee}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									联系电话
								</template>
								{{show.tel}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									收货地址
								</template>
								{{show.address}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									状态
								</template>
								{{show.storekeeperId > 0 ? "已出货" : (show.reviewerId > 0 ? "已复核":"待复核")}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									复核人
								</template>
								{{show.reviewerName}}
							</el-descriptions-item>
							<el-descriptions-item>
								<template slot="label">
									复核时间
								</template>
								{{show.reviewerId > 0 ?  show.reviewerCheckTime : ""}}
							</el-descriptions-item>
							<el-descriptions-item v-if = "show.storekeeperId > 0">
								<template slot="label">
									仓管员
								</template>
								{{show.storekeeperName}}
							</el-descriptions-item>
							<el-descriptions-item v-if = "show.storekeeperId > 0">
								<template slot="label">
									出货时间
								</template>
								{{show.storekeeperCheckTime}}
							</el-descriptions-item>
						</el-descriptions>
					</el-form>
					<el-table
						:data="outStockDetail"
						border
						class="table"
						ref="multipleTable"
						header-cell-class-name="table-header"
						:cell-style="{padding:4+'px'}"
						style="margin-top:20px;"
						stripe
					>
						<el-table-column prop="id" label="序号" width="50">
							<template slot-scope="scope">
								{{scope.$index + 1}}
							</template>
						</el-table-column>
						<el-table-column prop="seriesName" label="名称" width = "220px"></el-table-column>
						<el-table-column prop="productName" label="型号"  width = "150px"></el-table-column>
						<el-table-column prop="outStockNum" label="出库数量"></el-table-column>
						<el-table-column prop="unit" label="单位" width = "50px"></el-table-column>
						<el-table-column prop="price" label="价格" width = "80px"><template slot-scope="scope">￥{{scope.row.price}}</template></el-table-column>
						<el-table-column prop="amount" label="金额" width = "80px"><template slot-scope="scope">￥{{scope.row.amount}}</template></el-table-column>
						<el-table-column prop="stockId" label="库存编号" width = "80px"><template slot-scope="scope">{{scope.row.stockId}}号</template></el-table-column>
						<el-table-column prop="remark" label="备注" width = "160px"></el-table-column>
						<el-table-column prop="createTime" label="创建时间" width = "160px"></el-table-column>
					</el-table>
				</el-tab-pane>
				<el-tab-pane label="产品图片" name="productImgsTab" v-if="show.imgs">
					<el-card v-for="img in show.imgs" shadow="hover" :body-style="{ padding: '2px' }" style="width:200px;float:left;margin:10px;">
						<el-image style="width:100%;height:100%;object-fit: cover;"
							class="table-td-thumb"
							:src="imgPrefix+img"
							:preview-src-list="[imgPrefix+img]"
						></el-image>
					</el-card>
				</el-tab-pane>
			</el-tabs>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showVisible = false">关闭</el-button>
            </span>
        </el-dialog>
		
		<!-- 地址列表 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false title="地址列表" :visible.sync="showExpressInfo" width="30%">
			<div class="text item" v-for="item in expressAddressKV" @dblclick="selectExpressAddress(item)">
				<el-row>
					<el-col :span="4">
						{{item.contact}}
					</el-col>
					<el-col :span="20">
						{{item.tel}}&nbsp;&nbsp;
						<el-tag type="success" v-if="item.acquiesce">默认</el-tag>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="20">
						{{item.address}}
					</el-col>
					<el-col :span="4">
						<el-button
                            type="text"
                            icon="el-icon-star"
                            @click="handleDefault(item.id)"
							v-if = "!item.acquiesce"
							v-prevent-re-click
                        >设置默认</el-button>
					</el-col>
				</el-row>
			</div>
        </el-dialog>
    </div>
</template>

<script>
import bus from '../../common/bus';
import { getControll } from '../../../utils/controlls';
import { fetchPersonalOutStockData, getCustomerKV, saveOutStock, deleteOutStock, getOutStock, getEnumValueKV, getOutStockDetail, exportOutStockById, getExpressAddressByCompanyId, setExpressAddressDefault, getBlob } from '../../../api/index';
export default {
    name: 'out-stock',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
			outStockDetail: [],
            editVisible: false,
			showVisible: false,
            pageTotal: 0,
            form: {},
			show:{},
            idx: -1,
            id: -1,
			expressCode:1011,
			cityKV:{},
			companyTypeKV:{},
			sourceKV:{},
			rules: {
                orderCompanyName: [{ required: true, message: '客户名称不能为空', trigger: 'blur' }],
                expressId: [{ required: true, message: '请选择送达方式', trigger: 'blur' }]
            },
			customersKV:[],
			expressKV:[],
			isDisabled:false,
			title:"",
			showExpressInfo : false,
			expressAddressKV:[],
			expressAddressAddShow:false,
			controll:{},
			imgPrefix:"/image",
			activeName:"baseTab"
        };
    },
    created() {
		this.controll = getControll("out-stock");
		bus.$on('out-stock', msg => {
            for (var key in msg) {
				this.$set(this.query, key, msg[key]);
			}
			this.getData();
        });
		this.getExpress();
		this.getCustomers();
        this.getData();
    },
    methods: {	
		//送达方式格式化
		expressFormat(row, column, cellValue){
			if (typeof(cellValue) === "undefined") {
				return;
			}
			let index = this.expressKV.findIndex(item => {
				if (item.key === cellValue) {
					return true;
				}
			});
			if (index === -1) return cellValue;
			return this.expressKV[index].value;
		},
		//获取产品信息
		getExpress() {
			getEnumValueKV(this.expressCode).then(res => {
				if (res.code == 0) {
					this.expressKV = res.data;
				} else {
					this.$message.error(`获取单位信息失败！` + res.message);
				}
			})
		},
		//获取客户
		getCustomers() {
			getCustomerKV().then(res => {
				if (res.code == 0) {
					this.customersKV = res.data;
				} else {
					this.$message.error(`获取渠道信息失败！` + res.message);
				}
			});
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchPersonalOutStockData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteOutStock(row.id).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
			this.title = "编辑";
			getOutStock(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
		handleShow(index, row) {
			this.show = row;
			getOutStockDetail(row.id).then(res => {
				if (res.code == 0) {
					this.outStockDetail = res.data.details;
					this.$set(this.show, "imgs", res.data.imgs);
					this.activeName = "baseTab";
					this.showVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
		},
		handlePrint(index, row) {
		
		},
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					saveOutStock(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							if (typeof(this.form.id) == "undefined") {
								this.getData();
							} else {
								this.$set(this.tableData, this.idx, this.form);
							}
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		exportOutStock(index, row){
			exportOutStockById(row.id).then(res => {
				if (res.code == 0) {
					//this.$router.push({path: "export-out-stock", query:{key: res.data}});
					var linkTag = document.createElement("a");
					linkTag.href = "/blob/export/view?printCode=3&fileTypeName=docx&key=" + res.data;			
					linkTag.click();
					linkTag.remove();
				} else {
					this.$message.error(`生成合同失败！` + res.message);
				}
			});
		},
		handleExpressAddress(orderCompanyId) {
			getExpressAddressByCompanyId(orderCompanyId).then(res => {
				if (res.code == 0) {
					this.expressAddressKV = res.data;
					this.showExpressInfo = true;
				} else {
					this.$message.error(`获取地址信息失败！` + res.message);
				}
			});
		},
		selectExpressAddress(item) {
			this.form.address = item.address;
			this.form.addressee = item.contact;
			this.form.tel = item.tel;
			this.showExpressInfo = false;
		},
		handleDefault(id) {
			setExpressAddressDefault(id).then(res => {
				if (res.code == 0) {
					this.handleExpressAddress(this.form.orderCompanyId);
				} else {
					this.$message.error(`设置为默认地址失败！` + res.message);
				}
			});
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}

.text {
	font-size: 14px;
}

.item {
	margin-bottom: 18px;
	border-bottom:1px solid #E0E0E0;
}

</style>
